import { render, staticRenderFns } from "./AIGenerateFooter.vue?vue&type=template&id=405cddc1&scoped=true&"
import script from "./AIGenerateFooter.vue?vue&type=script&lang=js&"
export * from "./AIGenerateFooter.vue?vue&type=script&lang=js&"
import style0 from "./AIGenerateFooter.vue?vue&type=style&index=0&id=405cddc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405cddc1",
  null
  
)

export default component.exports